import React from 'react';
import { IconProps } from '../types';

export const ContentCreationIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.333252 1.66663H31.6666V30.3333H0.333252V1.66663ZM2.33325 3.66663V28.3333H29.6666V3.66663H2.33325Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.333252 6.99996H31.6666V8.99996H0.333252V6.99996Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.66658 13.6666H15.6666V23.6666H5.66658V13.6666ZM7.66658 15.6666V21.6666H13.6666V15.6666H7.66658Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9999 13.6666H26.3333V15.6666H18.9999V13.6666Z"
            fill={color}
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M18.9999 19H23.6666V21H18.9999V19Z" fill={color} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99992 1.66663V8.99996H6.99992V1.66663H8.99992Z"
            fill={color}
        />
    </svg>
);
